export const platformList = [
  {
    "id": 0,
    "name": "All",
    "slug": "all",
  },
  {
    "id": 4,
    "name": "PC",
    "slug": "pc",
    "games_count": 489950,
    "image_background": "https://media.rawg.io/media/games/021/021c4e21a1824d2526f925eff6324653.jpg",
  },
  {
    "id": 2,
    "name": "PlayStation",
    "slug": "playstation",
    "platforms": [
      {
        "id": 187,
        "name": "PlayStation 5",
        "slug": "playstation5",
        "games_count": 717,
        "image_background": "https://media.rawg.io/media/games/f24/f2493ea338fe7bd3c7d73750a85a0959.jpeg",
        "image": null,
        "year_start": 2020,
        "year_end": null,
      },
      {
        "id": 18,
        "name": "PlayStation 4",
        "slug": "playstation4",
        "games_count": 6503,
        "image_background": "https://media.rawg.io/media/games/9fa/9fa63622543e5d4f6d99aa9d73b043de.jpg",
        "image": null,
        "year_start": null,
        "year_end": null,
      },
      {
        "id": 16,
        "name": "PlayStation 3",
        "slug": "playstation3",
        "games_count": 3516,
        "image_background": "https://media.rawg.io/media/games/4a0/4a0a1316102366260e6f38fd2a9cfdce.jpg",
        "image": null,
        "year_start": null,
        "year_end": null,
      },
      {
        "id": 15,
        "name": "PlayStation 2",
        "slug": "playstation2",
        "games_count": 1950,
        "image_background": "https://media.rawg.io/media/games/e60/e601c02ec49ef4f1d5ef147994b3935f.jpg",
        "image": null,
        "year_start": null,
        "year_end": null,
      },
      {
        "id": 27,
        "name": "PlayStation",
        "slug": "playstation1",
        "games_count": 1596,
        "image_background": "https://media.rawg.io/media/games/f77/f77510051b6a61decc35c5257193fc9e.jpg",
        "image": null,
        "year_start": null,
        "year_end": null,
      },
      {
        "id": 19,
        "name": "PS Vita",
        "slug": "ps-vita",
        "games_count": 1884,
        "image_background": "https://media.rawg.io/media/games/f99/f9979698c43fd84c3ab69280576dd3af.jpg",
        "image": null,
        "year_start": null,
        "year_end": null,
      },
      {
        "id": 17,
        "name": "PSP",
        "slug": "psp",
        "games_count": 1591,
        "image_background": "https://media.rawg.io/media/games/837/837a609b0584db5d03534c8e767861b1.jpg",
        "image": null,
        "year_start": null,
        "year_end": null,
      },
    ],
  },
  {
    "id": 3,
    "name": "Xbox",
    "slug": "xbox",
    "platforms": [
      {
        "id": 1,
        "name": "Xbox One",
        "slug": "xbox-one",
        "games_count": 5421,
        "image_background": "https://media.rawg.io/media/games/fc1/fc1307a2774506b5bd65d7e8424664a7.jpg",
        "image": null,
        "year_start": null,
        "year_end": null,
      },
      {
        "id": 186,
        "name": "Xbox Series S/X",
        "slug": "xbox-series-x",
        "games_count": 645,
        "image_background": "https://media.rawg.io/media/games/253/2534a46f3da7fa7c315f1387515ca393.jpg",
        "image": null,
        "year_start": 2020,
        "year_end": null,
      },
      {
        "id": 14,
        "name": "Xbox 360",
        "slug": "xbox360",
        "games_count": 2770,
        "image_background": "https://media.rawg.io/media/games/f46/f466571d536f2e3ea9e815ad17177501.jpg",
        "image": null,
        "year_start": null,
        "year_end": null,
      },
      {
        "id": 80,
        "name": "Xbox",
        "slug": "xbox-old",
        "games_count": 712,
        "image_background": "https://media.rawg.io/media/games/459/459ac8745027643ed7338516c0025cf7.jpg",
        "image": null,
        "year_start": null,
        "year_end": null,
      },
    ],
  },
  {
    "id": 3,
    "name": "iOS",
    "slug": "ios",
    "games_count": 75552,
    "image_background": "https://media.rawg.io/media/games/d1f/d1f872a48286b6b751670817d5c1e1be.jpg",
  },
  {
    "id": 21,
    "name": "Android",
    "slug": "android",
    "games_count": 51335,
    "image_background": "https://media.rawg.io/media/games/daa/daaee07fcb40744d90cf8142f94a241f.jpg",
  },
  {
    "id": 5,
    "name": "Apple Macintosh",
    "slug": "mac",
    "platforms": [
      {
        "id": 5,
        "name": "macOS",
        "slug": "macos",
        "games_count": 99400,
        "image_background": "https://media.rawg.io/media/games/588/588c6bdff3d4baf66ec36b1c05b793bf.jpg",
        "image": null,
        "year_start": null,
        "year_end": null,
      },
      {
        "id": 55,
        "name": "Classic Macintosh",
        "slug": "macintosh",
        "games_count": 680,
        "image_background": "https://media.rawg.io/media/games/38a/38af969459ad6e5de116ec8a4a84218c.jpg",
        "image": null,
        "year_start": null,
        "year_end": null,
      },
      {
        "id": 41,
        "name": "Apple II",
        "slug": "apple-ii",
        "games_count": 423,
        "image_background": "https://media.rawg.io/media/games/271/271b23ee662efa73d8feb8712186e372.jpg",
        "image": null,
        "year_start": null,
        "year_end": null,
      },
    ],
  },
  {
    "id": 6,
    "name": "Linux",
    "slug": "linux",
    "games_count": 73138,
    "image_background": "https://media.rawg.io/media/games/d1a/d1a2e99ade53494c6330a0ed945fe823.jpg",
  },
  {
    "id": 7,
    "name": "Nintendo",
    "slug": "nintendo",
    "platforms": [
      {
        "id": 7,
        "name": "Nintendo Switch",
        "slug": "nintendo-switch",
        "games_count": 5033,
        "image_background": "https://media.rawg.io/media/games/7cf/7cfc9220b401b7a300e409e539c9afd5.jpg",
        "image": null,
        "year_start": null,
        "year_end": null,
      },
      {
        "id": 8,
        "name": "Nintendo 3DS",
        "slug": "nintendo-3ds",
        "games_count": 1751,
        "image_background": "https://media.rawg.io/media/games/b4e/b4e4c73d5aa4ec66bbf75375c4847a2b.jpg",
        "image": null,
        "year_start": null,
        "year_end": null,
      },
      {
        "id": 9,
        "name": "Nintendo DS",
        "slug": "nintendo-ds",
        "games_count": 2462,
        "image_background": "https://media.rawg.io/media/games/694/6940fa3fbe0d836e4a272c468e65e480.jpg",
        "image": null,
        "year_start": null,
        "year_end": null,
      },
      {
        "id": 13,
        "name": "Nintendo DSi",
        "slug": "nintendo-dsi",
        "games_count": 37,
        "image_background": "https://media.rawg.io/media/screenshots/078/078629e997421ca28e9098bd7a87cb10.jpg",
        "image": null,
        "year_start": null,
        "year_end": null,
      },
      {
        "id": 10,
        "name": "Wii U",
        "slug": "wii-u",
        "games_count": 1241,
        "image_background": "https://media.rawg.io/media/games/e4f/e4fb3fd188f61fabec48dca22e6ef28a.jpg",
        "image": null,
        "year_start": null,
        "year_end": null,
      },
      {
        "id": 11,
        "name": "Wii",
        "slug": "wii",
        "games_count": 2320,
        "image_background": "https://media.rawg.io/media/games/693/693952316d4b90984a92e7ab0f5c9b81.jpg",
        "image": null,
        "year_start": null,
        "year_end": null,
      },
      {
        "id": 105,
        "name": "GameCube",
        "slug": "gamecube",
        "games_count": 640,
        "image_background": "https://media.rawg.io/media/games/0a5/0a56e2bb9ce95359e69ff9689c553a45.jpg",
        "image": null,
        "year_start": null,
        "year_end": null,
      },
      {
        "id": 83,
        "name": "Nintendo 64",
        "slug": "nintendo-64",
        "games_count": 363,
        "image_background": "https://media.rawg.io/media/games/5a1/5a145fe3002fc988140f7f00edcb9715.jpg",
        "image": null,
        "year_start": null,
        "year_end": null,
      },
      {
        "id": 24,
        "name": "Game Boy Advance",
        "slug": "game-boy-advance",
        "games_count": 954,
        "image_background": "https://media.rawg.io/media/screenshots/52b/52b958a7b263d4f264648b710e76a236.jpg",
        "image": null,
        "year_start": null,
        "year_end": null,
      },
      {
        "id": 43,
        "name": "Game Boy Color",
        "slug": "game-boy-color",
        "games_count": 412,
        "image_background": "https://media.rawg.io/media/screenshots/6ca/6ca508f924da59e8cab1610b30117b56.jpeg",
        "image": null,
        "year_start": null,
        "year_end": null,
      },
      {
        "id": 26,
        "name": "Game Boy",
        "slug": "game-boy",
        "games_count": 605,
        "image_background": "https://media.rawg.io/media/games/32d/32d851318b042aba3df62e52d868d599.jpg",
        "image": null,
        "year_start": null,
        "year_end": null,
      },
      {
        "id": 79,
        "name": "SNES",
        "slug": "snes",
        "games_count": 935,
        "image_background": "https://media.rawg.io/media/games/98c/98c87b286cd2a2ba942167df384a9bd3.jpg",
        "image": null,
        "year_start": null,
        "year_end": null,
      },
      {
        "id": 49,
        "name": "NES",
        "slug": "nes",
        "games_count": 958,
        "image_background": "https://media.rawg.io/media/games/0c8/0c8e70a85fd2a341c77ada2a919ca0e1.jpg",
        "image": null,
        "year_start": null,
        "year_end": null,
      },
    ],
  },
  {
    "id": 9,
    "name": "Atari",
    "slug": "atari",
    "platforms": [
      {
        "id": 28,
        "name": "Atari 7800",
        "slug": "atari-7800",
        "games_count": 64,
        "image_background": "https://media.rawg.io/media/screenshots/565/56504b28b184dbc630a7de118e39d822.jpg",
        "image": null,
        "year_start": null,
        "year_end": null,
      },
      {
        "id": 31,
        "name": "Atari 5200",
        "slug": "atari-5200",
        "games_count": 64,
        "image_background": "https://media.rawg.io/media/screenshots/61a/61a60e3ee55941387681eaa59e3becbf.jpg",
        "image": null,
        "year_start": null,
        "year_end": null,
      },
      {
        "id": 23,
        "name": "Atari 2600",
        "slug": "atari-2600",
        "games_count": 286,
        "image_background": "https://media.rawg.io/media/games/23e/23eecccb588a4a9c97f35ebf8f9f00ef.jpg",
        "image": null,
        "year_start": null,
        "year_end": null,
      },
      {
        "id": 22,
        "name": "Atari Flashback",
        "slug": "atari-flashback",
        "games_count": 30,
        "image_background": "https://media.rawg.io/media/screenshots/2aa/2aa07f58491e14b0183333f8956bc802.jpg",
        "image": null,
        "year_start": null,
        "year_end": null,
      },
      {
        "id": 25,
        "name": "Atari 8-bit",
        "slug": "atari-8-bit",
        "games_count": 306,
        "image_background": "https://media.rawg.io/media/screenshots/518/5180f00f3d4626c94bdb0259a07a2903.jpg",
        "image": null,
        "year_start": null,
        "year_end": null,
      },
      {
        "id": 34,
        "name": "Atari ST",
        "slug": "atari-st",
        "games_count": 836,
        "image_background": "https://media.rawg.io/media/screenshots/8dd/8dd23d8d30d988035a06a8f8c462f135.jpg",
        "image": null,
        "year_start": null,
        "year_end": null,
      },
      {
        "id": 46,
        "name": "Atari Lynx",
        "slug": "atari-lynx",
        "games_count": 56,
        "image_background": "https://media.rawg.io/media/screenshots/575/575b2838392ed177dd7d2c734c682f93.jpg",
        "image": null,
        "year_start": null,
        "year_end": null,
      },
      {
        "id": 50,
        "name": "Atari XEGS",
        "slug": "atari-xegs",
        "games_count": 22,
        "image_background": "https://media.rawg.io/media/screenshots/769/7691726d70c23c029903df08858df001.jpg",
        "image": null,
        "year_start": null,
        "year_end": null,
      },
      {
        "id": 112,
        "name": "Jaguar",
        "slug": "jaguar",
        "games_count": 37,
        "image_background": "https://media.rawg.io/media/screenshots/7dd/7dd630a9b38257450b53099932d3047d.jpg",
        "image": null,
        "year_start": null,
        "year_end": null,
      },
    ],
  },
  {
    "id": 166,
    "name": "Commodore / Amiga",
    "slug": "commodore-amiga",
    "games_count": 2061,
    "image_background": "https://media.rawg.io/media/screenshots/e11/e1152adc84db3182ab4c8bca6505fbd2.jpg",
  },
  {
    "id": 11,
    "name": "SEGA",
    "slug": "sega",
    "platforms": [
      {
        "id": 167,
        "name": "Genesis",
        "slug": "genesis",
        "games_count": 824,
        "image_background": "https://media.rawg.io/media/games/360/360f00cbb4b4364b9af0e7ff8e397b65.jpg",
        "image": null,
        "year_start": null,
        "year_end": null,
      },
      {
        "id": 107,
        "name": "SEGA Saturn",
        "slug": "sega-saturn",
        "games_count": 333,
        "image_background": "https://media.rawg.io/media/games/45d/45da4dc311d84b79230317d7b24a3dec.jpg",
        "image": null,
        "year_start": null,
        "year_end": null,
      },
      {
        "id": 119,
        "name": "SEGA CD",
        "slug": "sega-cd",
        "games_count": 160,
        "image_background": "https://media.rawg.io/media/screenshots/d5f/d5f66d7e5f49a1ac445983b8be60b118.jpg",
        "image": null,
        "year_start": null,
        "year_end": null,
      },
      {
        "id": 117,
        "name": "SEGA 32X",
        "slug": "sega-32x",
        "games_count": 46,
        "image_background": "https://media.rawg.io/media/screenshots/dee/dee085e88fb024149a8a88d8f0cf9f91.jpg",
        "image": null,
        "year_start": null,
        "year_end": null,
      },
      {
        "id": 74,
        "name": "SEGA Master System",
        "slug": "sega-master-system",
        "games_count": 218,
        "image_background": "https://media.rawg.io/media/screenshots/0d7/0d7036d9cbcb1b8319530eb951c0159a.jpg",
        "image": null,
        "year_start": null,
        "year_end": null,
      },
      {
        "id": 106,
        "name": "Dreamcast",
        "slug": "dreamcast",
        "games_count": 347,
        "image_background": "https://media.rawg.io/media/screenshots/aa0/aa042192185dc638e57605c134d19e9c.jpg",
        "image": null,
        "year_start": null,
        "year_end": null,
      },
      {
        "id": 77,
        "name": "Game Gear",
        "slug": "game-gear",
        "games_count": 212,
        "image_background": "https://media.rawg.io/media/games/b21/b21555abc69d04d9b5d7663d478ca81e.jpg",
        "image": null,
        "year_start": null,
        "year_end": null,
      },
    ],
  },
  {
    "id": 111,
    "name": "3DO",
    "slug": "3do",
    "games_count": 94,
    "image_background": "https://media.rawg.io/media/screenshots/d5f/d5f66d7e5f49a1ac445983b8be60b118.jpg",
  },
  {
    "id": 12,
    "name": "Neo Geo",
    "slug": "neogeo",
    "games_count": 111,
    "image_background": "https://media.rawg.io/media/screenshots/4cc/4ccee6c3e367f4dd94d19d4857dfc1c9.jpeg",
  },
  {
    "id": 171,
    "name": "Web",
    "slug": "web",
    "games_count": 239731,
    "image_background": "https://media.rawg.io/media/screenshots/ad4/ad445a12ee46543d4d117f3893041ebf.jpg",
  },
];

export const flattenPlatformList = platformList.reduce((prev, curr) => [...prev, curr, ...(curr.platforms || [])], []);
